import "./DeeplinkRedirect.css"

type DeeplinkRedirectProps = {
  status: "loading" | "success" | "error";
  message: string;
  handleRetry?: () => void;
  handleGoHome?: () => void;
};

const DeeplinkRedirect = ({
  status,
  message,
  handleRetry = () => {
    window.location.reload();
  },
  handleGoHome = () => {
    window.location.href = "https://squaay.com";
  },
}: DeeplinkRedirectProps) => {
  return (
    <div className="oauth-redirect-container">
      <div className="oauth-blobs">
        <div className="oauth-blob oauth-blob-1"></div>
        <div className="oauth-blob oauth-blob-2"></div>
      </div>

      <div className="oauth-content">
        {status === "loading" && (
          <div className="oauth-loading">
            <div className="oauth-logo">S</div>
            <div>
              <h2 className="oauth-title">Connecting to Squaay</h2>
              <p className="oauth-subtitle">
                {message || "Please wait while we authenticate your session..."}
              </p>
              <div className="status-badge status-loading">PROCESSING</div>
            </div>
            <div className="oauth-spinner">
              <div className="spinner"></div>
              <div className="spinner"></div>
              <div className="spinner"></div>
            </div>
            <p className="oauth-message">
              ⏱️ This usually takes a few seconds. Do not close this tab.
            </p>
          </div>
        )}

        {status === "success" && (
          <div className="oauth-success">
            <div className="success-icon">✓</div>
            <div>
              <h2 className="oauth-title">Welcome Back!</h2>
              <p className="oauth-subtitle">
                {message ||
                  "Your authentication was successful. Opening Squaay..."}
              </p>
              <div className="status-badge status-success">SUCCESS</div>
            </div>
            <p className="oauth-message">
              🚀 If the app doesn't open automatically, you'll be redirected to
              download it.
            </p>
          </div>
        )}

        {status === "error" && (
          <div className="oauth-error">
            <div className="error-icon">✕</div>
            <div>
              <h2 className="oauth-title">{message || "Redirect Failed"}</h2>
              <p className="oauth-subtitle">{message}</p>
              <div className="status-badge status-error">ERROR</div>
            </div>
            <div className="error-actions">
              <button
                className="error-btn error-btn-primary"
                onClick={handleRetry}
              >
                🔄 Try Again
              </button>
              <button
                className="error-btn error-btn-secondary"
                onClick={handleGoHome}
              >
                🏠 Go to Home
              </button>
            </div>
            <p className="oauth-message">
              💬 If the problem persists, contact{" "}
              <a href="mailto:support@squaay.com" style={{ color: "#06b6d4" }}>
                support@squaay.com
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeeplinkRedirect;
